export default {
  getOrderList: '/gateway/capp/mallcenter/PropSaleForAppRpcService/queryOrderList'
}
